// vendor modules
import React from "react"
import PropTypes from "prop-types"

// components
import { SelectBooleanTriplet } from "quorumdesign"

const TripletFilter = (props) => {
    if (
        props.searchFilterTerm &&
        [
            (props.leftText || "").toString().toLowerCase(),
            (props.centerText || "").toString().toLowerCase(),
            (props.rightText || "").toString().toLowerCase(),
        ].some((text) => text.includes(props.searchFilterTerm.toLowerCase()))
    ) {
        if (props.setFilterGroupContainsSearchFilterTerm) {
            props.setFilterGroupContainsSearchFilterTerm(true)
        } else {
            // not marked required
            console.error(
                `Missing props.setFilterGroupContainsSearchFilterTerm — ${props.searchFilterTerm} contained in "${props.leftText}, ${props.centerText}, ${props.rightText}".`,
            )
        }
        if (props.setFilterContainsSearchFilterTerm) {
            props.setFilterContainsSearchFilterTerm(true)
        } else {
            // not marked required
            console.error(
                `Missing props.setFilterContainsSearchFilterTerm — ${props.searchFilterTerm} contained in "${props.leftText}, ${props.centerText}, ${props.rightText}".`,
            )
        }
    }

    return (
        <SelectBooleanTriplet
            centerText={props.centerText}
            deserializedValue={props.value}
            falseText={props.rightText}
            isNullable={props.isNullable}
            isTriplet
            publishChange={props.publishChange}
            searchFilterTerm={props.searchFilterTerm}
            trueText={props.leftText}
        />
    )
}

TripletFilter.propTypes = {
    publishChange: PropTypes.func.isRequired,
    displayLabel: PropTypes.string,
    value: PropTypes.string,
    leftText: PropTypes.string,
    centerText: PropTypes.string,
    rightText: PropTypes.string,
    helpText: PropTypes.string,
    isNullable: PropTypes.bool,
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm: PropTypes.string,
    // from app/static/frontend/search-new/components/Filter/index.js
    setFilterContainsSearchFilterTerm: PropTypes.func,
    // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
    setFilterGroupContainsSearchFilterTerm: PropTypes.func,
}

TripletFilter.defaultProps = {
    leftText: "Less",
    centerText: "Equal",
    rightText: "Greater",
    isNullable: true,
}

export default TripletFilter
